import React, {
    PropTypes, Component
} from 'react';
import {FormControl, Form, FormGroup, Button, Checkbox, Alert} from 'react-bootstrap';
import {connect} from 'react-redux';
import {UserLogin} from './actions';
import CryptoJS from 'crypto-js';
import {history} from '../../redux/store';
import {apibase} from '../../api/api';

class LoginForm extends Component {

    state = {
        showAlert: false,
        alertText: '',
    };

    /**
     *  On form sign in we should pass login and password hash to the action and clear password field when
     *  login attempt is finished. And then redirect to main page.
     */
    onSignIn(e) {
        e && e.preventDefault();
        this.setState({
            showAlert: false,
        });
        const login = this.login.value;
        const pwdHash = this.ph ? this.ph.toUpperCase() : CryptoJS.MD5(this.password.value).toString().toUpperCase();
        const rememberMe = this.remember.checked;
        const password = this.password;
        this.props.UserLogin(login, pwdHash, rememberMe).then(
            () => {
                password.value = '';
                history.push('/');
            },
            error => {
                if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                    this.setState({
                        showAlert: true,
                        alertText: 'Невірний логін чи пароль'
                    });
                } else {
                    this.setState({
                        showAlert: true,
                        alertText: 'Помилка при спробі з\'єднання. Перевірте підключення до мережі інтернет'
                    });
                }
            }
        );
    }

    componentDidMount() {
        const {query} = this.props;

        if (query.ph && !this.state.showAlert) {
            this.ph = query.ph;
            this.login.value = query.login;
            this.onSignIn()
        } else if (query.password && !this.state.showAlert) {
            this.password.value = query.password;
            this.login.value = query.login;
            this.onSignIn()
        }
    }

    render() {
        const {login, isAuthenticated} = this.props;
        if (isAuthenticated) {
            history.push('/');
        }

        const alert = <Alert bsStyle="danger" onDismiss={() => this.setState({showAlert: false})}>
            {this.state.alertText}
        </Alert>;

        const styles = {
            logo: {
                maxWidth: "160px",
                width: "100%",
                maxHeight: "100%",
            },
            text: {
                fontSize: "2em",
                fontWeight: "bold"
            },
            textSm: {
                fontSize: "1.4em",
                fontWeight: "bold"
            }
        };

        const forgotUrl = apibase + '/password_change';

        return (
            <Form onSubmit={this.onSignIn.bind(this)}>
                <div style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    marginBottom: "20px"
                }}>
                    <div className="col-md-4"><img src="/images/logo.gif" alt="Школа Афины" style={styles.logo}/></div>
                    <div className="col-md-1"></div>
                    <div style={styles.text} className="col-md-7 text-success text-left hidden-sm hidden-xs">ОСОБИСТИЙ
                        КАБІНЕТ КОРИСТУВАЧА
                    </div>
                    <div style={styles.textSm} className="col-md-7 text-success mt20 visible-sm visible-xs">ОСОБИСТИЙ
                        КАБІНЕТ КОРИСТУВАЧА
                    </div>
                </div>
                <div className="row"><p className="text-center mb30">Будь-ласка, введіть логін і пароль для входу в особистий кабінет</p></div>
                <div className="form-inputs">
                    {this.state.showAlert ? alert : ''}
                    <FormGroup bsSize="large">
                        <FormControl type="text" value={login} placeholder="Логін" inputRef={(ref) => {
                            this.login = ref;
                        }}/>
                    </FormGroup>
                    <FormGroup bsSize="large">
                        <FormControl
                            type="password"
                            placeholder="Пароль"
                            inputRef={(ref) => {
                                this.password = ref;
                            }}
                        />
                    </FormGroup>
                    <FormGroup bsSize="small">
                        <Checkbox inputRef={(ref) => {
                            this.remember = ref;
                        }}>Запам'ятати мене</Checkbox>
                    </FormGroup>
                </div>
                <Button
                    type="submit"
                    bsStyle="success" bsSize="large" block
                    onClick={this.onSignIn.bind(this)}>Увійти</Button>
                <br/>
                <div className="row text-center"><a href={forgotUrl}>Забули пароль?</a></div>
            </Form>
        );
    }
}

LoginForm.propTypes = {
    UserLogin: PropTypes.func.isRequired,
    login: PropTypes.string,
    isAuthenticated: PropTypes.bool.isRequired,
};
LoginForm.defaultProps = {};

/**
 * Restore login from Redux storage
 * @param state
 * @return object
 */
function mapStateToProps(state) {
    return {
        login: state.auth.credentials.login,
        isAuthenticated: state.auth.isAuthenticated,
    };
}

export default connect(mapStateToProps, {UserLogin})(LoginForm);



/** WEBPACK FOOTER **
 ** ./src/modules/auth/LoginForm.js
 **/